import BaseDetails from "./BaseDetails";

class FormDetails extends BaseDetails {
  constructor(name = "", description = "") {
    super(name, description);
  }
}

export default FormDetails;
